/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-unresolved */
import React from "react";
import PropTypes from "prop-types";
import { Container, Box, Typography } from "@mui/material";
import TextFieldComponent from "components/TextField";
import ButtonComponent from "components/Button";
import CheckboxComponent from "components/Checkbox";
import {
  schema, getTextfieldData, getButtonData, getCheckboxData, getCheckboxDataWithoutFood, getSelectFieldData
} from "./helper";
import SelectFieldComponent from "components/SelectField";

const PrivateProductEditor = ({
  setState, product, addUpdateProductToShopClicked, cancelEdit, addCategoryClicked, categoriesOption,
}) => {
  const {
    prod_id, name, description, is_food, is_nonveg, category,
  } = product;

  const [blur, setblur] = React.useState({
    name: false,
    description: false,
    is_food: false,
    is_nonveg: false,
    category: false
  });

  const onFinish = () => {
    addUpdateProductToShopClicked({
      prod_id, name, description, is_food, is_nonveg, category,
    });
  };

  const handleTextFieldChange = (event, field) => {
    setState(event.target.value, field);
    setblur({ ...blur, [field]: true });
  };

  const handleCheckBoxChange = (event, field) => {
    setState(event.target.checked, field);
    setblur({ ...blur, [field]: true });
  };

  const handleSelectFieldChange = (event, field) => {
    setState(event.target.value, field);
    setblur({ ...blur, [field]: true });

  };

  const hasError = () => {
    try {
      return !schema.validateSync(product);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.name || blur.description || blur.is_food || blur.is_nonveg || blur.category );

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, product);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

  return (
    <Container>
      <Box display="flex" flexWrap="wrap">
        {getTextfieldData(name, description).map((element) => (
          <Box className="textfield" m={2}>
            <TextFieldComponent
              required
              label={element.label}
              value={element.value}
              error={!!getError(element.onChangeField)}
              helperText={getError(element.onChangeField)}
              onChange={(event) => handleTextFieldChange(event, element.onChangeField)}
            />
          </Box>
        ))}
        {process.env.REACT_APP_FOOD_PRODUCT === true &&
              getCheckboxData(is_food, is_nonveg).map((element) => (
                  <Box className="textfield" m={2}>
                    <CheckboxComponent
                        required
                        label={element.label}
                        value={element.value}
                        onChange={(event) => handleCheckBoxChange(event, element.onChangeField)}
                    />
                  </Box>
              ))
        }

        {getSelectFieldData(category).map((element) => (
        <Box className="textfield" m={2}>
          <SelectFieldComponent
              label={element.label}
              value={element.value}
              options={categoriesOption}
              onChange={(event) => handleSelectFieldChange(event, element.onChangeField)}
          />
        </Box>
        ))}
      </Box>
      <br />
      <Typography align="center">
        {getButtonData(onFinish, cancelEdit, hasError, isTouched).map((element) => (
          <ButtonComponent
              sx={{
                m: 2,
              }}
            type={element.type}
            variant={element.variant}
            onClick={element.onClick}
            disabled={element.disabled}
            name={element.name}
          />
        ))}
      </Typography>
    </Container>
  );
};

PrivateProductEditor.propTypes = {
  setState: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  addUpdateProductToShopClicked: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
};

export default PrivateProductEditor;
